export default __webpack_public_path__ + "static/P_SearchThumb_IN-9408WQHD_Downloads-eb22f0b7b754ef4e71f431fe8edeac27.webp";